import styled from 'styled-components'
import tw from 'twin.macro'

export const Root = styled.div`
  ${tw`grid grid-flow-col auto-cols-min	gap-x-2`};
`

export const Input = styled.input`
  appearance: none;
  display: block;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0;
  margin-top: 3px;
  border-radius: 0.75rem;
  background: var(--color-white);
  border: solid 1px var(--color-dark-grey);
  outline: none;

  &:hover {
    background-color: var(--color-white);
  }

  &:checked {
    background-color: var(--color-gold);
    box-shadow: inset 0 0 0 3px var(--color-white);
  }

  &:focus {
    box-shadow: inset 0 0 0 3px var(--color-white), 0 0 0 3px var(--color-gold-lightest);
  }
`

export const ChoiceLabel = styled.label`
  white-space: nowrap;
  user-select: none;
`
